// export const dev = 'https://dev.hykrsol.com/assetmgmtdev/';
// export const prod = 'https://dev.hykrsol.com/assetmgmt/';
export const devapi = 'https://devapi.anikinitek.com/assetmgmtdev/';
export const mobile = 9494951828;
export const videoURL = 'http://192.168.101.3:8081/zpool/ingest/'
// Development is the safe default. Production builds replace this file with
// base-url.prod.ts through angular.json.
export const BASE_URL = devapi